import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { ILaunchWebAuthoringAction } from '../../../../ts/ServerApi/types/actionNames';
import { newMetricForDatasource } from '../../../actions/spaces/NewMetricForDatasourceAction';
import { IEntityAction } from './IEntityAction';
import { isSingleDatasourceWithExtract, isSingleEmbeddedDatasource } from './IEntityActionHelpers';

export const NewMetricEntityAction: IEntityAction<IContentInfo<'datasource'>, ILaunchWebAuthoringAction> = {
  name: 'new_metric',
  translateName: Messages.newMetric,
  isVisible: (targetItems: IContentInfo[]) => {
    return FeatureFlags.metricsAuthoringPathEnabled && !isSingleEmbeddedDatasource(targetItems) && isSingleDatasourceWithExtract(targetItems);
  },
  isClickable: (availableActions: ILaunchWebAuthoringAction, targetItems: IContentInfo[]) =>
      targetItems.length === 1 && availableActions && availableActions.launchWebAuthoring,
  createReduxAction: (targetItems: IContentInfo[]) => {
    if (targetItems.length !== 1) {
      return;
    }

    const item = targetItems[0];
    if (item.contentType === 'datasource') {
      return newMetricForDatasource(item);
    }
  }
};
